export default "__VITE_ASSET__XMiQovxt__"